import { Map } from 'immutable';
const cacheSelector = (state) => state.get('cache', Map());
export default cacheSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/cacheSelector.js
 **/